/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromptLibraryCategory } from './PromptLibraryCategory';
import {
    PromptLibraryCategoryFromJSON,
    PromptLibraryCategoryFromJSONTyped,
    PromptLibraryCategoryToJSON,
    PromptLibraryCategoryToJSONTyped,
} from './PromptLibraryCategory';

/**
 * 
 * @export
 * @interface GetPromptLibraryResponse
 */
export interface GetPromptLibraryResponse {
    /**
     * 
     * @type {Array<PromptLibraryCategory>}
     * @memberof GetPromptLibraryResponse
     */
    categories: Array<PromptLibraryCategory>;
}

/**
 * Check if a given object implements the GetPromptLibraryResponse interface.
 */
export function instanceOfGetPromptLibraryResponse(value: object): value is GetPromptLibraryResponse {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function GetPromptLibraryResponseFromJSON(json: any): GetPromptLibraryResponse {
    return GetPromptLibraryResponseFromJSONTyped(json, false);
}

export function GetPromptLibraryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromptLibraryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': ((json['categories'] as Array<any>).map(PromptLibraryCategoryFromJSON)),
    };
}

export function GetPromptLibraryResponseToJSON(json: any): GetPromptLibraryResponse {
    return GetPromptLibraryResponseToJSONTyped(json, false);
}

export function GetPromptLibraryResponseToJSONTyped(value?: GetPromptLibraryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categories': ((value['categories'] as Array<any>).map(PromptLibraryCategoryToJSON)),
    };
}

